// extracted by mini-css-extract-plugin
export var addButton = "_5x-d";
export var bullets = "_5x-e";
export var compact = "_5x-2";
export var container = "_5x-j";
export var extendedWarrantyModal = "_5x-f";
export var learn = "_5x-l";
export var learnMore = "_5x-g";
export var offeringOption = "_5x-3";
export var offeringPrice = "_5x-8";
export var offeringSubtitle = "_5x-7";
export var offeringTitle = "_5x-6";
export var offeringsContainer = "_5x-0";
export var pdpTilesBackground = "_5x-n";
export var plan = "_5x-m";
export var regular = "_5x-1";
export var remove = "_5x-k";
export var seeDetailsIcon = "_5x-i";
export var seeDetailsLink = "_5x-h";
export var selectedOption = "_5x-4";
export var shieldIcon = "_5x-b";
export var shieldIconCompact = "_5x-c";
export var subtitle = "_5x-a";
export var title = "_5x-9";
export var unselectedOption = "_5x-5";